import { Table } from '@hulu/react-style-components';
import styled, { css } from 'styled-components';

export const StyledTable = styled(Table)`
  border-collapse: collapse;

  th,
  td {
    letter-spacing: 0;
  }
`;

export const HeaderIconBasedStyles = css`
  min-width: 11px;
  height: 11px;
  margin: ${({ theme: { spacers } }): string => `0 ${spacers!.spacer01}`};

  &:hover {
    cursor: pointer;
  }
`;

export const stickyColumn = css`
  position: sticky;
  left: 0;
`;
